import React from 'react';

import { UserMenu } from 'components/UserMenu';

import { URLS } from 'constants/urls';

import { StyledHeader, StyledHeaderChildren, StyledHeaderActions, StyledShowUserMenu } from './styled';

const Header = ({ children }) => {
  return (
    <StyledHeader>
      <StyledHeaderChildren>{children}</StyledHeaderChildren>

      <StyledShowUserMenu>
        <StyledHeaderActions>
          <a href={URLS.movidesk} target="_blank" rel="noopener noreferrer">
            Central de Ajuda
          </a>
          <UserMenu />
        </StyledHeaderActions>
      </StyledShowUserMenu>
    </StyledHeader>
  );
};

export { Header };
